module.exports = __webpack_public_path__ + "img/FreelancerCircleDesktop.52c8d1dd.webp";